var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotPopupButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.737,
    height: 67.737,
    viewBox: "0 0 67.737 67.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_54323",
    x: 0,
    y: 0,
    width: 67.737,
    height: 67.737,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_159_40",
    "data-name": "Component 159 \\u2013 40",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_54323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54323-2",
    "data-name": "Path 54323",
    d: "M24.869,0A24.869,24.869,0,1,1,0,24.869,24.869,24.869,0,0,1,24.869,0Z",
    transform: "translate(9 6)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chatbot",
    transform: "translate(13.264 14.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46815",
    "data-name": "Group 46815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54321",
    "data-name": "Path 54321",
    d: "M22.136,28.886A9.038,9.038,0,0,0,13.125,20.4h-3.1a9.038,9.038,0,0,0-9.011,8.486A1.678,1.678,0,0,0,0,30.425v3.5A1.678,1.678,0,0,0,1.676,35.6H3.033V28.749H2.384a7.682,7.682,0,0,1,7.641-6.993h3.1a7.682,7.682,0,0,1,7.641,6.993h-.648V35.6h1.356a1.678,1.678,0,0,0,1.676-1.676v-3.5A1.678,1.678,0,0,0,22.136,28.886Z",
    transform: "translate(0 -20.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54322",
    "data-name": "Path 54322",
    d: "M109.586,158.1H98.927a1.859,1.859,0,0,0-1.857,1.857v8.45a1.859,1.859,0,0,0,1.857,1.857h2.325l2.261,2.676a.678.678,0,0,0,1.036,0l2.261-2.676h2.777a1.859,1.859,0,0,0,1.857-1.857v-8.45A1.859,1.859,0,0,0,109.586,158.1Zm-2.851,3.4a.678.678,0,1,1-.678.678A.678.678,0,0,1,106.735,161.5Zm-5.245,0a.678.678,0,1,1-.678.678A.678.678,0,0,1,101.49,161.5Zm6.147,4.115a4.813,4.813,0,0,1-6.762,0,.678.678,0,1,1,.9-1.015,3.459,3.459,0,0,0,4.962,0,.678.678,0,0,1,.9,1.015Z",
    transform: "translate(-92.681 -151.874)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotPopupButton);
export default __webpack_public_path__ + "static/media/chatbot-popup-button.91774152734c0c978c8032c1e9b5f9fb.svg";
export { ForwardRef as ReactComponent };